import { useState } from 'react'

import { INITIAL_STATE } from 'modules/lead/context'
import { LeadData } from 'modules/lead/types'

const useLeadDataState = () => {
  const [showConfirm, setShowConfirm] = useState<boolean>(INITIAL_STATE.leadData.showConfirm)
  const [isLoading, setIsLoading] = useState<boolean>(INITIAL_STATE.leadData.isLoading)
  const [data, setData] = useState<LeadData>(INITIAL_STATE.leadData.data)

  return {
    showConfirm,
    setShowConfirm,
    isLoading,
    setIsLoading,
    data,
    setData
  }
}

export default useLeadDataState
